module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [(_vm.hasAccount) ? _c('div', {
    staticClass: "has-account-box"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('customerForm.not')) + "\n    " + _vm._s(_vm.inputFirstName) + "?\n    "), _c('a', {
    on: {
      "click": _vm.logoutSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('customerForm.signOut')))])]) : _vm._e(), _vm._v(" "), _c('form', {
    ref: "customerForm",
    attrs: {
      "data-vv-scope": "customer-form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.nextStep('customer-form')
      }
    }
  }, [(!_vm.isCorporate) ? _c('div', {
    staticClass: "customer-form"
  }, [_c('h2', {
    staticClass: "margin-t-z margin-b-s"
  }, [_vm._v(_vm._s(_vm.$t('customerForm.yourInfo')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-6 columns padding-r-s small-padding-h-z"
  }, [_c('div', {
    class: ['field-group', {
      'field-error': _vm.error.firstName
    }]
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.$t('customerForm.firstName')) + " (" + _vm._s(_vm.inputFirstName.length) + "/30)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputFirstName),
      expression: "inputFirstName"
    }],
    class: ['field-text', (_vm.userLoggedIn ? 'disabled' : '')],
    attrs: {
      "type": "text",
      "name": "fname",
      "placeholder": "John",
      "disabled": _vm.userLoggedIn,
      "maxlength": "30",
      "autofocus": "!userLoggedIn"
    },
    domProps: {
      "value": (_vm.inputFirstName)
    },
    on: {
      "change": function($event) {
        _vm.gtagTrack('First Name', _vm.inputFirstName)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputFirstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.firstName),
      expression: "error.firstName"
    }],
    staticClass: "field-error-message"
  }, [_vm._v(_vm._s(_vm.error.firstName))])])]), _vm._v(" "), _c('div', {
    staticClass: "medium-6 columns padding-l-s small-padding-h-z"
  }, [_c('div', {
    class: ['field-group', {
      'field-error': _vm.error.lastName
    }]
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.$t('customerForm.lastName')) + " (" + _vm._s(_vm.inputLastName.length) + "/30)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputLastName),
      expression: "inputLastName"
    }],
    class: ['field-text', (_vm.userLoggedIn ? 'disabled' : '')],
    attrs: {
      "type": "text",
      "name": "lname",
      "placeholder": "Doe",
      "disabled": _vm.userLoggedIn,
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.inputLastName)
    },
    on: {
      "change": function($event) {
        _vm.gtagTrack('Last Name', _vm.inputFirstName)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputLastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.lastName),
      expression: "error.lastName"
    }],
    staticClass: "field-error-message"
  }, [_vm._v(_vm._s(_vm.error.lastName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-12 columns"
  }, [_c('div', {
    class: ['field-group', {
      'field-error': _vm.error.email
    }]
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.$t('common.email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputEmail),
      expression: "inputEmail"
    }],
    class: ['field-text', (_vm.userLoggedIn ? 'disabled' : '')],
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "johndoe@gmail.com",
      "disabled": _vm.userLoggedIn
    },
    domProps: {
      "value": (_vm.inputEmail)
    },
    on: {
      "change": function($event) {
        _vm.gtagTrack('Email', _vm.inputFirstName)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error.email),
      expression: "error.email"
    }],
    staticClass: "field-error-message"
  }, [_vm._v(_vm._s(_vm.error.email))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-12 columns margin-b-s"
  }, [_c('mobile-input', {
    ref: "userMobile",
    attrs: {
      "needVerification": true,
      "mobile": _vm.mobile,
      "dialCode": _vm.dialCode,
      "required": true,
      "checkUser": true
    },
    on: {
      "verified": _vm.mobileVerified,
      "updateMobile": _vm.updateMobileInfo,
      "emptyPhone": function($event) {
        _vm.mobile = ''
      },
      "loginUser": _vm.loginUser,
      "nonUser": _vm.nonUser
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('guest-form', {
    ref: "guestForm",
    on: {
      "clicked": _vm.enableGuestForm,
      "valid": _vm.validGuestForm,
      "updateInfo": _vm.guestUpdateInfo
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCorporate),
      expression: "!isCorporate"
    }]
  }, [_c('password-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userLoggedIn),
      expression: "!userLoggedIn"
    }],
    ref: "userPassword",
    on: {
      "clicked": _vm.clickedCreateAccount,
      "valid": _vm.isPasswordValid
    }
  })], 1), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.adaTrigger = !_vm.adaTrigger
      }
    }
  }, [_c('icon', {
    class: {
      'accessible': true, 'active': _vm.adaTrigger
    },
    attrs: {
      "name": "wheelchair"
    }
  })], 1), _vm._v(" "), _c('span', [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.adaTrigger),
      expression: "adaTrigger"
    }],
    staticClass: "adaWrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-12 columns margin-b-xs"
  }, [_c('label', {
    staticClass: "ada"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wheelChair),
      expression: "wheelChair"
    }],
    attrs: {
      "type": "checkbox",
      "id": "wheelChair"
    },
    domProps: {
      "checked": Array.isArray(_vm.wheelChair) ? _vm._i(_vm.wheelChair, null) > -1 : (_vm.wheelChair)
    },
    on: {
      "change": _vm.updateAda,
      "__c": function($event) {
        var $$a = _vm.wheelChair,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.wheelChair = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.wheelChair = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.wheelChair = $$c
        }
      }
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('customerForm.iHaveWheelchair')) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-12 columns"
  }, [_c('label', {
    staticClass: "ada"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serviceDog),
      expression: "serviceDog"
    }],
    attrs: {
      "type": "checkbox",
      "id": "serviceDog"
    },
    domProps: {
      "checked": Array.isArray(_vm.serviceDog) ? _vm._i(_vm.serviceDog, null) > -1 : (_vm.serviceDog)
    },
    on: {
      "change": _vm.updateAda,
      "__c": function($event) {
        var $$a = _vm.serviceDog,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.serviceDog = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.serviceDog = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.serviceDog = $$c
        }
      }
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t('customerForm.iHaveServiceDog')) + "\n              ")])])])])])], 1), _vm._v(" "), _c('div', {
    class: ['margin-b-s showhide-fadeslide margin-t-xs', {
      'hide': !_vm.signupFail
    }]
  }, [_c('div', {
    staticClass: "alert error"
  }, [(!_vm.emailExistsError) ? _c('span', [_vm._v(_vm._s(_vm.signupFailMessage))]) : _vm._e(), _vm._v(" "), (_vm.emailExistsError) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.$t('customerForm.emailExist')) + "\n          "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.forceShowForm
    }
  }, [_vm._v(_vm._s(_vm.$t('customerForm.clickHere')))]), _vm._v(" \n          " + _vm._s(_vm.$t('customerForm.toSignIn')) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('customerForm.otherwisePlease')) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-6 columns margin-t-m page-actions-wrap"
  }, [_c('a', {
    staticClass: "op-btn btn-lg btnBack",
    attrs: {
      "href": "#/service"
    },
    on: {
      "click": function($event) {
        _vm.backToServiceSelection($event)
      }
    }
  }, [_c('icon', {
    staticClass: "margin-r-xs",
    attrs: {
      "name": "chevron-left"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('common.back')) + "\n        ")], 1), _vm._v(" "), _c('label', {
    staticClass: "margin-t-xs"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('customerForm.previous')) + "\n          " + _vm._s(_vm.$t('customerForm.serviceSelection')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 columns margin-t-m page-actions-wrap text-right"
  }, [_c('a', {
    class: ['op-btn btn-success btn-lg btnContinue', {
      loading: _vm.signupLoading
    }],
    attrs: {
      "href": "#/payment"
    },
    on: {
      "click": function($event) {
        _vm.submitForm($event)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.continue')) + "\n          "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.signupLoading),
      expression: "!signupLoading"
    }],
    staticClass: "margin-l-xs",
    attrs: {
      "name": "chevron-right"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.signupLoading),
      expression: "signupLoading"
    }],
    staticClass: "loaderx margin-l-xs"
  }, [_c('icon', {
    staticClass: "magin-r-xs",
    attrs: {
      "name": "refresh",
      "spin": ""
    }
  })], 1)], 1), _vm._v(" "), _c('label', {
    staticClass: "margin-t-xs"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.next')) + "\n          " + _vm._s(_vm.$t('customerForm.paymentDetails')) + "\n        ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "submitBtn",
    attrs: {
      "type": "submit"
    }
  })])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4cd3149c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cd3149c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer/CustomerForm.vue
// module id = 2087
// module chunks = 0